import { useRoleColor } from "../helper/roleHelper";
import Loading from "./loading";
import React from "react";
import Pagination from "./pagination";

export const Table = ({
  data,
  header,
  loading,
  hasPagination,
  setPage,
  totalCount,
  currentPage,
  totalPageCount,
  containerClassName,
}) => {
  const { mainColor } = useRoleColor();
  return (
    <div
      className={`w-full h-auto rounded-xl overflow-hidden bg-white pb-8 ${containerClassName}`}
    >
      <div
        className={"max-[1400px]:max-h-[410px] max-[1400px]:overflow-y-scroll"}
      >
        <div
          className={`text-white p-4 px-6 overflow-x-auto`}
          style={{ backgroundColor: mainColor }}
        >
          <div className="md:grid flex grid-cols-12 md:gap-1 gap-4 items-center mb-2">
            {header.map((head) => {
              return (
                <div
                  key={head.name}
                  className={`text-center col-span-${head.width}`}
                >
                  {head.name}
                </div>
              );
            })}
          </div>
        </div>
        {!!data && data.length === 0 && !loading && (
          <div className={"text-center w-full mt-4"}>هیچ سطری وجود ندارد</div>
        )}
        <Loading center color={"blue"} isLoading={loading} className={"mt-2"} />
        {data.map((item, index) => {
          return (
            <div className="bg-white border-2 border-gray-100 rounded-xl text-gray-900 text-sm p-4 mx-2 mt-2 overflow-x-auto">
              <div className="md:grid flex grid-cols-12 md:gap-1 gap-4 items-center w-full">
                {header.map((head) => {
                  return (
                    <div
                      key={index}
                      className={`text-center col-span-${head.width} justify-center items-center flex`}
                    >
                      {head.render({
                        ...item,
                        rowIndex: currentPage
                          ? currentPage * 10 + index + 1
                          : index + 1,
                      })}
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
        {hasPagination && (
          <Pagination
            onChange={setPage}
            totalPageCount={totalPageCount}
            currentPageNumber={currentPage}
          />
        )}
        {totalCount && totalCount !== 0 && totalCount > 0 && (
          <div
            style={{ padding: "0 20px" }}
            className="mt-[-30px] md:mt-[-60px]"
          >
            <p>تعداد کل: {totalCount}</p>
          </div>
        )}
      </div>
    </div>
  );
};
